import React from "react";
import styled from "styled-components";
import BWModels from "@benjamin-west-rpm2/benjamin-west-models";

import { FormGrid, FormikForm } from "../../../../../forms";
import { ActionButtons } from "../../../../../forms/ActionButtons";
import { inputs } from "../../../../../inputs/inputConfigs";
import { unitOfMeasureDataComponentId } from "../UnitOfMeasureContainer";

const Wrapper = styled.div``;

const fields = {
  groups: [
    {
      items: [
        {
          input: inputs.name,
          grid: { xs: 12 },
        },
        {
          input: { ...inputs.description, required: true },
          grid: { xs: 12 },
        },
      ],
    },
  ],
};

export const CreateUnitOfMeasure = ({
  handleCreateUnitOfMeasure,
  closeModalDialog,
}) => {
  return (
    <FormikForm
      initialValues={{ name: "", description: "" }}
      onSubmit={handleCreateUnitOfMeasure}
      validationSchema={BWModels.loadSchema("UnitOfMeasure")}
    >
      {({ handleSubmit, values, ...formikProps }) => (
        <Wrapper>
          <FormGrid fields={fields} {...formikProps} />
          <ActionButtons
            onSend={handleSubmit}
            onCancel={closeModalDialog}
            sendButtonText="Create"
            listeners={[unitOfMeasureDataComponentId]}
            isModal
          />
        </Wrapper>
      )}
    </FormikForm>
  );
};
